import { NativeSelect } from "@replicate/ui";
import { RunWithContext } from "../api-playground/run-with";
import icons from "../icons";

export function LanguagePicker({
  value,
  onChange,
}: {
  value: RunWithContext;
  onChange: (value: RunWithContext) => void;
}) {
  const startElement: JSX.Element | undefined = {
    [RunWithContext.NodeJS]: <icons.languages.NodeJSIcon />,
    [RunWithContext.Python]: <icons.languages.PythonIcon />,
    [RunWithContext.HTTP]: <icons.languages.CurlIcon />,
  }[value];
  return (
    <NativeSelect
      id="language-picker"
      name="language"
      value={value}
      size="sm"
      startAdornment={<div className="w-4 h-4">{startElement}</div>}
      onChange={(e) => {
        onChange(e.target.value as RunWithContext);
      }}
    >
      <option value={RunWithContext.NodeJS}>Node.js</option>
      <option value={RunWithContext.Python}>Python</option>
      <option value={RunWithContext.HTTP}>HTTP</option>
    </NativeSelect>
  );
}
